import { fetchFile } from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
import ApiRoutes from "routing/ApiRoutes";
import { createLinkAndDownload } from "util/FileDownloadUtils";
const downloadFile = (exportJobId, filename) => {
  const href = qualifyUrl(ApiRoutes.MessagesController.jobResults(exportJobId, filename).url);
  createLinkAndDownload(href, filename);
};
export const exportSearchMessages = (exportPayload, searchId, mimeType, filename) => {
  const { url } = ApiRoutes.ExportJobsController.exportSearch(searchId);
  return fetchFile("POST", qualifyUrl(url), exportPayload, mimeType).then((result) => downloadFile(result, filename)).catch(() => {
    UserNotification.error(i18n.t("notifications.export_failed", { ns: "common" }));
  });
};
export const exportSearchTypeMessages = (exportPayload, searchId, searchTypeId, mimeType, filename) => {
  const { url } = ApiRoutes.ExportJobsController.exportSearchType(searchId, searchTypeId);
  return fetchFile("POST", qualifyUrl(url), exportPayload, mimeType).then((result) => downloadFile(result, filename)).catch(() => {
    UserNotification.error(i18n.t("notifications.export_widget_failed", { ns: "common" }));
  });
};
